import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import { MARKETS, PRODUCT_TABS } from '@/components/app/product/components/@shared/type';

import BundleModel from '@/models/bundle.model';
import ProductModel from '@/models/product.model';

export function isBundle(data: BundleModel | ProductModel): data is BundleModel {
  if (data.market === MARKETS.BUNDLE) {
    return true;
  }

  return (data as BundleModel).bundleItems !== undefined;
}

// Product routes are always `/web/{slug}` or `/web/{slug}/{tab}`, so the tab
// is derived positionally instead of by prop-drilling `initialTab`, which lets
// the tabs UI stay mounted across `/web/{slug}` <-> `/web/{slug}/{tab}` navigations.
export function getTabFromPathname(pathname: string): PRODUCT_TABS {
  const tabSegment = pathname.split('/').filter(Boolean)[2];
  return Object.values(PRODUCT_TABS).includes(tabSegment as PRODUCT_TABS)
    ? (tabSegment as PRODUCT_TABS)
    : PRODUCT_TABS.CONTENT;
}

type LifetimePricingInput = Pick<
  ProductModel,
  'regularPrice' | 'salePrice' | 'discount' | 'price'
>;

export function getLifetimePricing(data: LifetimePricingInput) {
  const lastPrice = data.regularPrice || 0;
  // const price = lastPrice - (data.salePrice || 0);
  // const price = data.salePrice;
  const price = data.price;
  return { price, lastPrice, discount: data.discount || 0 };
}

type OneYearSubscriptionPricingInput = Pick<
  ProductModel,
  | 'subscriptionPriceOneYear'
  | 'salePriceSubscriptionOneYear'
  | 'discountSubscriptionOneYear'
  | 'percentTypeSubscriptionOneYear'
  | 'price'
  | 'saleEndedAt'
>;

export function getOneYearSubscriptionPricing(data: OneYearSubscriptionPricingInput) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const discountIsValid = data.saleEndedAt > currentTimeInSeconds;
  const lastPrice = data.subscriptionPriceOneYear || 0;
  const price = discountIsValid ? data.salePriceSubscriptionOneYear || 0 : data.price;
  const discount = discountIsValid ? data.discountSubscriptionOneYear || 0 : 0;

  return { price, lastPrice, discount };
}

export function isAnnualDefault(
  data: Pick<
    ProductModel,
    'subscriptionDefaultPriceIsOneYear' | 'regularPrice' | 'isSubscription'
  >,
): boolean {
  const isOneYear =
    !!data.isSubscription &&
    (data.subscriptionDefaultPriceIsOneYear === true ||
      !data.regularPrice ||
      data.regularPrice === 0);
  return isOneYear;
}

export function formatParagraphNewLine(text: string): React.ReactElement[] {
  return text.split('\n').map((str) => <Text type={TEXT_TYPE.P}>{str}</Text>);
}
